import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_SURPRISE } from '@/modules/surprise/router';
import { surpriseService } from '@/services/surprise';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useSurpriseCategoryAdd() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        name: '',
        isPublished: false
    });

    const validations = {
        name: { required }
    };

    const v$ = useVuelidate(validations, model);

    const create = crudAction.excuteAndNotify({
        validator: v$,
        request: () => surpriseService.category.create(model.name, model.isPublished),
        onSuccess: () => router.push({ name: ROUTE_NAME_SURPRISE.CATEGORY.INDEX })
    });

    return { model, v$, create };
}
